/**
 * React Starter Kit for Firebase
 * https://github.com/kriasoft/react-firebase-starter
 * Copyright (c) 2015-present Kriasoft | MIT License
 */

import React from 'react';
import Container from '@material-ui/core/Container';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';

import { useAuth } from '../hooks';

const useStyles = makeStyles(theme => ({
  root: {
    paddingTop: theme.spacing(2),

    [theme.breakpoints.up('sm')]: {
      paddingTop: '10vh',
    },

    [theme.breakpoints.up('md')]: {
      paddingTop: '15vh',
    },
  },
  title: {
    paddingBottom: '1rem',
    fontWeight: 300,
    fontSize: '1.75rem',
    [theme.breakpoints.up('sm')]: {
      fontSize: '2.5rem',
    },
  },
  subTitle: {
    paddingBottom: '1rem',
    fontWeight: 300,
    fontSize: '1.125rem',
    [theme.breakpoints.up('sm')]: {
      fontSize: '1.5rem',
    },
  },
  actions: {
    paddingTop: '1rem',
  },
  button: {
    boxShadow: 'none',
    // backgroundColor: '#555',
    '&:hover': {
      // backgroundColor: '#666',
    },
  },
  image: {
    width: '100%',
    height: 'auto',
  },
}));

function Home(props) {
  const { relay, data, ...other } = props;
  const s = useStyles();
  const auth = useAuth();

  function signIn() {
    auth.signIn();
  }

  return (
    <Container className={s.root} {...other}>
      <Grid container spacing={2} alignItems="center">
        <Grid item xs={12} md={6}>
          <Typography className={s.title} variant="h3">
            User Story Mapping Tool
          </Typography>
          <Typography className={s.subTitle} variant="h5">
            to design the software that matters
          </Typography>
          <div className={s.actions}>
            <Button
              className={s.button}
              size="large"
              color="primary"
              variant="contained"
              onClick={signIn}
            >
              Connect with Asana
            </Button>
          </div>
        </Grid>
        <Grid item xs={12} md={6}>
          <img
            className={s.image}
            src="https://storage.googleapis.com/s.storymap.cc/user-story-map.png"
            alt="User Story Map"
          />
        </Grid>
      </Grid>
    </Container>
  );
}

export default Home;
